import * as React from 'react';

import { clsx } from 'clsx';
import { useSelector } from 'react-redux';

import * as styles from './SearchBlock.css';
import { Label } from '@cian/ui-kit';
import { selectHasMortgageDisclaimer } from '../../selectors/adBanner';

interface ISearchBlockProps {
  backgroundNode: React.ReactNode;
  adBanner: React.ReactNode;
  isNewFilters: boolean;
  section: string;
  label?: string;
  isRedesignEnabled: boolean;
}

export const SearchBlock: React.FC<React.PropsWithChildren<ISearchBlockProps>> = ({
  backgroundNode,
  adBanner,
  children,
  isNewFilters,
  section,
  label,
  isRedesignEnabled,
}) => {
  const isDailyRent = section === 'daily-rent';
  const hasMortgageDisclaimer = useSelector(selectHasMortgageDisclaimer);

  return (
    <div
      data-testid="SearchBlock"
      className={clsx(
        styles['c-filters'],
        isNewFilters && styles['c-filters--new'],
        isDailyRent && styles['c-filters-dailyrent'],
        adBanner && isRedesignEnabled && styles['c-filters--with-ad'],
        hasMortgageDisclaimer && isRedesignEnabled && styles['c-filters--with-mortgage'],
      )}
    >
      <div className={styles['c-filters-content']}>
        <div className={clsx(styles['c-filters-inner'], isRedesignEnabled && styles['redesign'])}>
          {children}
          {!isRedesignEnabled && adBanner}
        </div>
      </div>
      <div className={styles['background']}>{backgroundNode}</div>
      {label && (
        <div className={styles['label']}>
          <Label>{label}</Label>
        </div>
      )}
      {isRedesignEnabled && adBanner && (
        <div className={clsx(styles['ad-banner'], hasMortgageDisclaimer && styles['ad-banner--mortgage'])}>
          <div className={styles['ad-banner-inner']}>{adBanner}</div>
        </div>
      )}
    </div>
  );
};
